import { useQuery } from "@tanstack/react-query";
import type { Read } from "@/components/ui/box.schema";
import { useAuth } from "@/contexts/AuthContext";
import { ApiError } from "@/lib/api/client";
import { courseReadingsApi, type CourseReadings } from "@/lib/api/courseReadings";
export function useReadings(course: string, preparation: boolean, enabled = true) {
  const { me } = useAuth();
  return useQuery({ queryKey: ["course-readings", me?.tenant_id, me?.user_id, course, preparation],
    queryFn: () => courseReadingsApi.read(course, preparation), enabled: enabled && !!course, retry: false });
}
export function readingsRead(query: ReturnType<typeof useReadings>): Read<CourseReadings> {
  if (query.error instanceof ApiError && [401, 403, 404].includes(query.error.status)) return { status: "forbidden" };
  if (!query.data) return query.isError ? { status: "failed", sentence: "Readings could not be read.", retry: () => void query.refetch() } : { status: "loading" };
  if (query.isError) return { status: "stale", last: query.data, readAt: query.data.read_at, sentence: "Readings could not refresh.", refresh: () => void query.refetch() };
  return { status: "ready", value: query.data, readAt: query.data.read_at };
}
